/* React 19 ignores defaultProps on function components. Semantic UI React still
 * relies on them, so missing defaults such as Form.Input's control drop the
 * field children. Apply those defaults before the element is created.
 */
const React = require('react')
const JsxRuntime = require('react/jsx-runtime')
const JsxDevRuntime = require('react/jsx-dev-runtime')

function isClassComponent(type: any): boolean {
    return typeof type === 'function' && !!(type.prototype && type.prototype.isReactComponent)
}

function applyDefaultProps(type: any, config: any) {
    const defaultProps = type?.defaultProps

    if (!defaultProps || typeof type !== 'function' || isClassComponent(type)) {
        return config
    }

    const props = config ? { ...config } : {}
    let applied = false

    for (const key in defaultProps) {
        if (Object.prototype.hasOwnProperty.call(defaultProps, key) && props[key] === undefined) {
            props[key] = defaultProps[key]
            applied = true
        }
    }

    return applied ? props : config
}

const originalCreateElement = React.createElement

React.createElement = function (type: any, config: any, ...children: any[]) {
    return originalCreateElement(type, applyDefaultProps(type, config), ...children)
}

if (typeof JsxRuntime.jsx === 'function') {
    const originalJsx = JsxRuntime.jsx
    const originalJsxs = JsxRuntime.jsxs

    JsxRuntime.jsx = (type: any, config: any, maybeKey?: any) =>
        originalJsx(type, applyDefaultProps(type, config), maybeKey)
    JsxRuntime.jsxs = (type: any, config: any, maybeKey?: any) =>
        originalJsxs(type, applyDefaultProps(type, config), maybeKey)
}

if (typeof JsxDevRuntime.jsxDEV === 'function') {
    const originalJsxDEV = JsxDevRuntime.jsxDEV

    JsxDevRuntime.jsxDEV = (type: any, config: any, maybeKey?: any, isStaticChildren?: boolean) =>
        originalJsxDEV(type, applyDefaultProps(type, config), maybeKey, isStaticChildren)
}

export {}
